// CSS
import '../../sass/third-party/archive-alpha_car_ads.scss'

// === COMPONENTS
import '../components/car-tease-gallery'

// Sélecteur de marque mobile (floating label) : redirige vers la page de la marque choisie
document.querySelectorAll('select[data-brand-redirect]').forEach((el) => {
  el.addEventListener('change', () => {
    if (el.value) {
      window.location.href = el.value
    }
  })
})
